<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2742.5661615120534!2d126.88621458213679!3d37.42220112501177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b6102e82be58f%3A0x584bd4b675b7bf0a!2z6rSR66qF7JetIOq1reygnOuUlOyekOyduO2BtOufrOyKpO2EsCBHSURD!5e0!3m2!1sko!2skr!4v1639968537523!5m2!1sko!2skr"
      width="100%"
    />
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMap',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
